import React from 'react';

export default function IndexSectionApplicationsLightReverse10() {
    return (
        <React.Fragment>
            <>
                <section className="py-10 bg-gray-50 overflow-hidden">
  <div className="container mx-auto px-4">
    <div className="py-20 px-8 md:px-16 overflow-hidden rounded-3xl bg-black opacity-80" style={{backgroundImage: 'url("https://static.shuffle.dev/uploads/files/9d/9dda6d0f3a27bf2a89e1082d3b457b83612163f7/betawall1.png")', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}}>
      <div className="max-w-7xl mx-auto">
        <div className="md:max-w-lg bg-black p-8 border border-white rounded-4xl">
          <h2 className="font-heading mb-6 text-4xl md:text-5xl text-gray-100 font-black tracking-tight">上线在即，9月见面</h2>
          <p className="mb-8 text-gray-200 font-bold">加入等待清单，进入beta社区</p>
          <div className="flex flex-wrap -m-2">
            <div className="w-full md:w-auto p-2"><a className="block w-full px-8 py-3.5 text-lg text-center text-white font-bold bg-white focus:ring-4 focus:ring-black rounded-full" href="https://t.me/+qjkfk6Si0bY5ZDJl">Join beta</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

